import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { MOBILE_ITEMS, visibleFor, visibleGroups } from './Menu';
import arquendaIcon from '../../assets/logos/arquenda-icon-white.svg';

/**
 * Barra lateral del panel: fija a 252px en escritorio, cajón sobre overlay
 * por debajo de 992px, más la barra inferior de cinco pestañas.
 *
 * El filtrado por rol es el mismo mecanismo de siempre —`item.roles`
 * contra `admin.role`, sin roles = visible para todos— sólo que ahora
 * vive en Menu.jsx para que la barra inferior lo comparta. Un grupo sin
 * items visibles no se dibuja.
 */

const isActive = (pathname, path) => pathname === path || pathname.startsWith(`${path}/`);

const ROLE_LABELS = {
  ADMIN: 'Administrador',
  ADMIN_ASSISTANT: 'Auxiliar Administrativo',
  ASSISTANT: 'Auxiliar',
};

const logout = () => {
  localStorage.removeItem('token');
  window.location.href = '/login';
};

const Sidebar = ({ open = false, setOpen = () => {} }) => {
  const { admin } = useAdmin();
  const { pathname } = useLocation();
  const close = () => setOpen(false);

  const groups = visibleGroups(admin?.role);
  const mobileItems = visibleFor(admin?.role, MOBILE_ITEMS);

  return (
    <Fragment>
      <div className={`ui-scrim${open ? ' ui-scrim--open' : ''}`} onClick={close} />

      <aside className={`ui-sidebar${open ? ' ui-sidebar--open' : ''}`}>
        <div className="ui-sidebar__brand">
          <img className="ui-sidebar__brand-logo" src={arquendaIcon} alt="" />
          <div>
            <div className="ui-sidebar__brand-name">Arquenda</div>
            <div className="ui-sidebar__brand-kicker">ADMINISTRACIÓN</div>
          </div>
          <button type="button" className="ui-sidebar__close" onClick={close} aria-label="Cerrar menú">
            <i className="ri-close-line" />
          </button>
        </div>

        <nav className="ui-sidebar__nav">
          {groups.map((group) => (
            <div className="ui-sidebar__group" key={group.menutitle}>
              <div className="ui-sidebar__group-label">{group.menutitle}</div>
              {group.Items.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={close}
                  className={`ui-sidebar__item${isActive(pathname, item.path) ? ' ui-sidebar__item--active' : ''}`}
                >
                  <i className={item.icon} />
                  <span>{item.title}</span>
                </Link>
              ))}
            </div>
          ))}
        </nav>

        <div className="ui-sidebar__user">
          <span className="ui-sidebar__avatar">
            {admin?.avatar ? <img src={admin.avatar} alt="" /> : <i className="ri-user-line" />}
          </span>
          <div className="ui-sidebar__identity">
            <div className="ui-sidebar__name">{admin?.name || '—'}</div>
            <div className="ui-sidebar__role">{ROLE_LABELS[admin?.role] || admin?.role || ''}</div>
          </div>
          <button type="button" className="ui-sidebar__logout" onClick={logout} aria-label="Cerrar sesión">
            <i className="ri-logout-box-r-line" />
          </button>
        </div>
      </aside>

      <nav className="ui-bottombar">
        {mobileItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`ui-bottombar__item${isActive(pathname, item.path) ? ' ui-bottombar__item--active' : ''}`}
          >
            <i className={item.icon} />
            <span>{item.title}</span>
          </Link>
        ))}
        <button type="button" className="ui-bottombar__item" onClick={() => setOpen(true)}>
          <i className="ri-menu-line" />
          <span>Menú</span>
        </button>
      </nav>
    </Fragment>
  );
};

export default Sidebar;
